import * as React from "react";
import Svg, { Path } from "react-native-svg";

function HeaderSearchIcon(props) {
  const { fill = "#000" } = props;

  return (
    <Svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
      <Path
        d="M7.927 0C3.556 0 0 3.556 0 7.927c0 4.37 3.556 7.926 7.927 7.926 4.37 0 7.926-3.555 7.926-7.926S12.298 0 7.927 0zm0 14.39a6.47 6.47 0 01-6.464-6.463 6.47 6.47 0 016.464-6.464 6.47 6.47 0 016.463 6.464 6.47 6.47 0 01-6.463 6.463z"
        fill={fill}
        fillOpacity={0.7}
      />
      <Path
        d="M17.785 16.75l-4.195-4.194a.731.731 0 10-1.034 1.034l4.195 4.195a.73.73 0 001.034 0 .731.731 0 000-1.034z"
        fill={fill}
        fillOpacity={0.7}
      />
    </Svg>
  );
}

export default HeaderSearchIcon;
